export default function LevelCompletedSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 67 17"
      shapeRendering="crispEdges"
      style={{
        display: "block",
        width: 67,
      }}
    >
      <path
        stroke="#000000"
        d="M1 0h65M0 1h1M66 1h1M0 2h1M66 2h1M0 3h1M3 3h6M11 3h6M19 3h6M28 3h6M36 3h3M43 3h6M51 3h5M58 3h6M66 3h1M0 4h1M3 4h1M8 4h1M11 4h1M16 4h1M19 4h1M22 4h1M24 4h2M28 4h1M33 4h1M36 4h1M38 4h1M43 4h1M48 4h1M51 4h1M55 4h1M58 4h1M63 4h1M66 4h1M0 5h1M3 5h1M5 5h4M11 5h1M13 5h2M16 5h1M19 5h1M21 5h1M23 5h1M25 5h1M28 5h1M30 5h2M33 5h1M36 5h1M38 5h1M43 5h1M45 5h4M51 5h2M54 5h2M58 5h1M60 5h4M66 5h1M0 6h1M3 6h1M5 6h1M11 6h1M13 6h2M16 6h1M19 6h1M21 6h1M23 6h1M25 6h1M28 6h1M33 6h1M36 6h1M38 6h1M43 6h1M48 6h1M52 6h1M54 6h1M58 6h1M63 6h1M66 6h1M0 7h1M3 7h1M5 7h4M11 7h1M13 7h2M16 7h1M19 7h1M21 7h1M23 7h1M25 7h1M28 7h1M30 7h4M36 7h1M38 7h3M43 7h1M45 7h4M52 7h1M54 7h1M58 7h1M60 7h4M66 7h1M0 8h1M3 8h1M8 8h1M11 8h1M16 8h1M19 8h1M21 8h1M23 8h1M25 8h1M28 8h1M30 8h1M36 8h1M40 8h1M43 8h1M48 8h1M52 8h1M54 8h1M58 8h1M63 8h1M66 8h1M0 9h1M3 9h6M11 9h6M19 9h7M28 9h3M36 9h5M43 9h6M52 9h3M58 9h6M66 9h1M0 10h1M66 10h1M0 11h1M3 11h61M66 11h1M0 12h1M3 12h1M63 12h1M66 12h1M0 13h1M3 13h61M66 13h1M0 14h1M66 14h1M0 15h1M66 15h1M1 16h65"
      />
      <path stroke="#3c2349" d="M1 1h65" />
      <path
        stroke="#4f365b"
        d="M1 2h65M1 3h2M9 3h2M17 3h2M25 3h3M34 3h2M39 3h4M49 3h2M56 3h2M64 3h2M1 4h2M9 4h2M17 4h2M26 4h2M34 4h2M39 4h4M49 4h2M56 4h2M64 4h2M1 5h2M9 5h2M17 5h2M26 5h2M34 5h2M39 5h4M49 5h2M56 5h2M64 5h2M1 6h2M6 6h5M17 6h2M26 6h2M34 6h2M39 6h4M49 6h3M55 6h3M64 6h2M1 7h2M9 7h2M17 7h2M26 7h2M34 7h2M41 7h2M49 7h3M55 7h3M64 7h2M1 8h2M9 8h2M17 8h2M26 8h2M31 8h5M41 8h2M49 8h3M55 8h3M64 8h2M1 9h2M9 9h2M17 9h2M26 9h2M31 9h5M41 9h2M49 9h3M55 9h3M64 9h2M1 10h65M1 11h2M64 11h2M1 12h2M64 12h2M1 13h2M64 13h2M1 14h65M1 15h65"
      />
      <path
        stroke="#ccffd2"
        d="M4 4h4M12 4h4M20 4h2M23 4h1M29 4h4M37 4h1M44 4h4M52 4h3M59 4h4M5 12h1M7 12h1M9 12h1M11 12h1M13 12h1M15 12h1M17 12h1M19 12h1M21 12h1M23 12h1M25 12h1M27 12h1M29 12h1M31 12h1M33 12h1M35 12h1M37 12h1M39 12h1M41 12h1M43 12h1M45 12h1M47 12h1M49 12h1M51 12h1M53 12h1M55 12h1M57 12h1M59 12h1M61 12h1"
      />
      <path
        stroke="#05fb4c"
        d="M4 5h1M12 5h1M15 5h1M20 5h1M22 5h1M24 5h1M29 5h1M32 5h1M37 5h1M44 5h1M53 5h1M59 5h1M4 6h1M12 6h1M15 6h1M20 6h1M22 6h1M24 6h1M29 6h4M37 6h1M44 6h4M53 6h1M59 6h4M4 7h1M12 7h1M15 7h1M20 7h1M22 7h1M24 7h1M29 7h1M37 7h1M44 7h1M53 7h1M59 7h1"
      />
      <path
        stroke="#00f81d"
        d="M4 8h4M12 8h4M20 8h1M22 8h1M24 8h1M29 8h1M37 8h3M44 8h4M53 8h1M59 8h4M4 12h1M6 12h1M8 12h1M10 12h1M12 12h1M14 12h1M16 12h1M18 12h1M20 12h1M22 12h1M24 12h1M26 12h1M28 12h1M30 12h1M32 12h1M34 12h1M36 12h1M38 12h1M40 12h1M42 12h1M44 12h1M46 12h1M48 12h1M50 12h1M52 12h1M54 12h1M56 12h1M58 12h1M60 12h1M62 12h1"
      />
    </svg>
  );
}
